
// eslint-disable import/no-anonymous-default-export
export default {
  dev: {
    API: {
      baseURL: "https://devhubopsapis.innofulfill.com/smcs-webapp",
      bffBaseURL: "https://devhubopsapis.innofulfill.com",
      // baseURL: "https://smcs-dev.hutechweb.com/smcs-webapp",
      // bffBaseURL: "https://smcs-dev.hutechweb.com",
      tatURL: "https://devapis.delcaper.com/routemaster/hubEstimate",
      reportGustTokenURL: "https://qaapis.hubops.innofulfill.com/datazip/fetch-guest-token",
      DrsMasterURL: "",
      delcaperURL: "https://devapis.delcaper.com",
      reportURL: "https://devhubopsapis.innofulfill.com",
      trainingVideoURL: "https://apis2.delcaper.com",
      pincodeServiceabilityBaseURL: "https://devapis2.delcaper.com/serviceability",
      lockSystemServiceURL: "https://devapis2.delcaper.com/lock-system-service",
      TAT_URL: "https://devapis2.delcaper.com/routemaster",
      reportBaseURL: "https://qareports.innofulfill.com",
    },
    auth: {
      domain: "smcs-prod.hutechweb.com",
      oauthDomain: "SMCS_POOL.auth.us-east-1.amazoncognito.com",
      userPoolWebClientId: "5764umttfqiplob9e337ar0v0m",
      userPoolId: "us-east-1_TD8m0Yrs9",
      region: "us-east-1",
      datazip_userName: "datazip.embed",
      datazip_password: "JNF0D*fa$cd4",
    },
  },
  qa: {
    API: {
      baseURL: "https://qaapis.hubops.innofulfill.com/smcs-webapp",
      bffBaseURL: "https://qaapis.hubops.innofulfill.com",
      tatURL: "https://qaapis.delcaper.com/routemaster/hubEstimate",
      reportGustTokenURL: "https://qaapis.hubops.innofulfill.com/datazip/fetch-guest-token",
      DrsMasterURL: "",
      delcaperURL: "https://qaapis.delcaper.com",
      reportURL: "https://qaapis.hubops.innofulfill.com",
      trainingVideoURL: "https://apis2.delcaper.com",
      logoutRedirectURL: "https://commonqa.innofulfill.com/",
      //logoutRedirectURL: "https://local.innofulfill.com:5173/",
      pincodeServiceabilityBaseURL: "https://qaapis2.delcaper.com/serviceability",
      lockSystemServiceURL: "https://qaapis2.delcaper.com/lock-system-service",
      TAT_URL: "https://qaapis2.delcaper.com/routemaster",
      reportBaseURL: "https://qareports.innofulfill.com",
      accessRolesBaseURL: "https://qaapis.hubops.sevasetu.in",
      accessRolesTenantId: "6979ea34da4d67ecf06ab962",
      rbacHubopsTenantId: "6979ea34da4d67ecf06ab962",
      rbacDefaultRoleId: "69d380f93b9552ac125bbaf1",
      rbacRoleIdMap: {
        DRIVER: "69d380ef3b9552ac125bbaed",
        OPERATOR: "69d380f93b9552ac125bbaf1",
      },
    },
    auth: {
      domain: "qaapis.hubops.innofulfill.com",
      oauthDomain: "smcs.auth.ap-south-1.amazoncognito.com",
      userPoolWebClientId: "69nb6vpga3k7v9au0r6ioovpo8",
      userPoolId: "ap-south-1_z5sdmVKiT",
      region: "ap-south-1",
      datazip_userName: "datazip.embed",
      datazip_password: "JNF0D*fa$cd4",
    },
  },
  uat: {
    API: {
      baseURL: "https://uatapis-hubops.innofulfill.com/smcs-webapp",
      bffBaseURL: "https://uatapis-hubops.innofulfill.com",
      tatURL: "https://qaapis.delcaper.com/routemaster/hubEstimate",
      reportGustTokenURL: "https://qaapis.hubops.innofulfill.com/datazip/fetch-guest-token",
      DrsMasterURL: "",
      delcaperURL: "https://qaapis.delcaper.com",
      reportURL: "https://uatapis-hubops.innofulfill.com",
      trainingVideoURL: "https://apis2.delcaper.com",
      logoutRedirectURL: "https://commonqa.innofulfill.com/",
      pincodeServiceabilityBaseURL: "https://uatapis2.delcaper.com/serviceability",
      lockSystemServiceURL: "https://uatapis2.delcaper.com/lock-system-service",
      TAT_URL: "https://qaapis2.delcaper.com/routemaster",
      reportBaseURL: "https://qareports.innofulfill.com",
    },
    auth: {
      domain: "smcs-uat.hutechweb.com",
      oauthDomain: "smcs.auth.ap-south-1.amazoncognito.com",
      userPoolWebClientId: "a3e0iaciccfeln7no5b467ab5",
      userPoolId: "ap-south-1_xoRMaTXJu",
      region: "ap-south-1",
      datazip_userName: "datazip.embed",
      datazip_password: "JNF0D*fa$cd4",
    },
  },
  prod: {
    API: {
      baseURL: "https://apis-hubops.innofulfill.com/smcs-webapp",
      bffBaseURL: "https://apis-hubops.innofulfill.com",
      tatURL: "https://apis.delcaper.com/routemaster/hubEstimate",
      reportGustTokenURL: "https://apis-hubops.innofulfill.com/datazip/fetch-guest-token",
      DrsMasterURL: "https://apis.delcaper.com/da-onboarding/",
      delcaperURL: "https://apis.delcaper.com",
      reportURL: "https://apis-hubops.innofulfill.com",
      trainingVideoURL: "https://apis2.delcaper.com",
      logoutRedirectURL: "https://common.innofulfill.com",
      pincodeServiceabilityBaseURL: "https://apis2.delcaper.com/serviceability",
      lockSystemServiceURL: "https://apis2.delcaper.com/lock-system-service",
      TAT_URL: "https://apis2.delcaper.com/routemaster",
      reportBaseURL: "https://reports.innofulfill.com",
      accessRolesBaseURL: "https://apis-hubops.innofulfill.com",
      accessRolesTenantId: "6995426f1040467031b7c8da",
      rbacHubopsTenantId: "6995426f1040467031b7c8da",
      rbacDefaultRoleId: "6a174d69993ad66163ab1947",
      rbacRoleIdMap: {
        DRIVER: "6a174cf6993ad66163ab18f3",
        OPERATOR: "6a174d69993ad66163ab1947",
      },
    },
    auth: {
      domain: "smcs-prod.hutechweb.com",
      oauthDomain: "smcs.auth.ap-south-1.amazoncognito.com",
      userPoolWebClientId: "168ssb7bu4v71556pd1017nl62",
      userPoolId: "ap-south-1_NR41y4LSv",
      region: "ap-south-1",
      datazip_userName: "datazip.embed",
      datazip_password: "JNF0D*fa$cd4",
    },
  },
};
